var render, staticRenderFns
import script from "./TableCellNumTestsPerPhysician.vue?vue&type=script&lang=js&"
export * from "./TableCellNumTestsPerPhysician.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e350fd4')) {
      api.createRecord('2e350fd4', component.options)
    } else {
      api.reload('2e350fd4', component.options)
    }
    
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/tracking-sheet/table-cells/TableCellNumTestsPerPhysician.vue"
export default component.exports